<template>
  <div class="pt-8 border-t border-primary flex flex-col gap-16 lg:flex-row lg:justify-between pb-safe">
    <div class="text-small-normal">© {{ new Date().getFullYear() }} Herbert Seidl. All rights reserved.</div>

    <div v-if="siteOptions?.data?.footerLegalMenu" class="footer__legal-menu flex gap-6 flex-wrap lg:flex-nowrap">
      <template v-for="menu in siteOptions?.data?.footerLegalMenu?.menuItems" :key="menu.label">
        <NuxtLink v-if="getLocaleUrl(menu)" :to="getLocaleUrl(menu)" class="text-regular-link text-accent" :aria-label="menu.label" :title="t('menu.navigateTo', { label: menu.label })">{{ menu.label }}</NuxtLink>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { SiteOption, StrapiResponse } from '~/types/strapi';

  const { t } = useI18n();
  const getLocaleUrl = useLocalizedUrl();
  const siteOptions = inject<Ref<StrapiResponse<SiteOption> | null>>('siteOptions');
</script>

<style></style>
